<a data-qa="gn-login-link" href="{{loginUrl}}" class="btn btn-sm btn-yellow"><span class="fa fa-lock">&nbsp;</span>Log
  In</a>
